import { Modal } from "react-bootstrap";
import { handleErrors } from "../modules/handleErrors";
import apiClient from "../api/apiClient";
import React, { useState } from "react";
import { toast } from "react-toastify";

const ModalPublishUnPublish = ({
  showModal,
  modalClose,
  mocko_id,
  fetchFeaturedMockups,
  publishValue,
  fetchBundleMockups,
  isUnblockRequest,
  isBundle,
  isLinkEnabled,
  isDisableEnableLinkRequest,
  viewMode,
  fetchAllDetails,
}) => {
  const [Loader, setLoader] = useState(false);
  const [message, setMessage] = useState(""); // for unblock request message
  const handlePublishUnPublish = async (e) => {
    e.preventDefault();

    const uploaddata = new FormData();
    uploaddata.append("is_published", publishValue == "true" ? true : false);

    try {
      setLoader(true);
      let result;
      if (isBundle) {
        result = await apiClient.patch(
          `/bundle-listings/${mocko_id}/`,
          uploaddata
        );
      } else {
        result = await apiClient.patch(`/listings/${mocko_id}/`, uploaddata);
      }

      setLoader(false);

      if (!result.ok) return handleErrors(result.data);
      toast.success(`${isBundle ? "Bundle" : "Listing"}  updated successfully`);

      if (viewMode === "detailed") {
        fetchAllDetails();
      } else {
        if (isBundle) {
          fetchBundleMockups();
        } else {
          fetchFeaturedMockups();
        }
      }
      modalClose();
    } catch (error) {
      setLoader(false);
    }
  };

  const handleEnableDisableSharableLink = async (e) => {
    e.preventDefault();

    const uploaddata = new FormData();
    uploaddata.append(
      "sharable_link_enabled",
      isLinkEnabled == true ? false : true
    );

    try {
      setLoader(true);

      const result = await apiClient.patch(
        `/listings/${mocko_id}/`,
        uploaddata
      );

      setLoader(false);

      if (!result.ok) return handleErrors(result.data);
      toast.success(`Listing updated successfully`);

      if (viewMode === "detailed") {
        fetchAllDetails();
      } else {
        fetchFeaturedMockups();
      }

      modalClose();
    } catch (error) {
      setLoader(false);
    }
  };

  const handleUnblockRequest = async (e) => {
    e.preventDefault();

    try {
      setLoader(true);
      const result = await apiClient.post(`/unblock/`, {
        mockup_id: mocko_id,
        message,
      });
      setLoader(false);

      if (!result.ok) return handleErrors(result.data);
      toast.success("Unblock request sent to admin");
      modalClose();
    } catch (error) {
      setLoader(false);
    }
  };

  return (
    <Modal
      show={showModal}
      onHide={modalClose}
      dialogClassName="alert-modal"
      centered
    >
      <Modal.Body
        style={{
          padding: "40px 30px",
          background: "#F8D4B7",
          borderTopRightRadius: "24px",
          borderBottomLeftRadius: "24px",
        }}
      >
        {isUnblockRequest ? (
          /*************** UNBLOCK REQUEST FLOW ***************/
          <section>
            <h5 className="mb-3 text-center">
              {isBundle ? "Mockup" : "Bundle"}#{mocko_id} – Request Unblock
            </h5>

            <div className="mb-3">
              <textarea
                className="form-control"
                rows="4"
                placeholder="Enter your message to admin"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
              />
            </div>

            <div className="text-center">
              <button
                disabled={Loader}
                className="btn grey-btn mb-3 px-5"
                style={{ width: "190px" }}
                onClick={handleUnblockRequest}
              >
                {Loader ? "Sending..." : "Send Request"}
              </button>
            </div>

            <div className="text-center">
              <button
                className="btn bg-white px-5"
                style={{ width: "190px", border: "2px solid #000" }}
                onClick={modalClose}
              >
                Cancel
              </button>
            </div>
          </section>
        ) : isDisableEnableLinkRequest ? (
          /*************** ENABLE/DISABLE SHARE LINK ***************/
          <section className="text-center">
            {isLinkEnabled ? (
              <p>
                Your sharable link will be disabled and no longer accessible.
              </p>
            ) : (
              <p>
                Your sharable link will be enabled and can be shared publicly.
              </p>
            )}

            <div className="text-center">
              <button
                disabled={Loader}
                className="btn grey-btn mb-3 px-5"
                style={{ width: "190px" }}
                onClick={handleEnableDisableSharableLink}
              >
                {Loader
                  ? "Processing..."
                  : isLinkEnabled
                  ? "Disable Link"
                  : "Enable Link"}
              </button>
            </div>

            <div className="text-center">
              <button
                className="btn bg-white px-5"
                style={{ width: "190px", border: "2px solid #000" }}
                onClick={modalClose}
              >
                Cancel
              </button>
            </div>
          </section>
        ) : (
          /*************** PUBLISH/UNPUBLISH FLOW ***************/
          <section className="text-center">
            {publishValue === "true" ? (
              <p>
                Your {isBundle ? "bundle" : "listing"} will be published to the
                marketplace.
              </p>
            ) : (
              <p>
                Your {isBundle ? "bundle" : "listing"} will be removed from the
                marketplace.
              </p>
            )}

            <div>
              <button
                disabled={Loader}
                className="btn grey-btn mb-3 px-5"
                style={{
                  width: "190px",
                  paddingTop: "8px",
                  paddingBottom: "8px",
                }}
                onClick={handlePublishUnPublish}
              >
                {Loader ? "Processing..." : "Proceed"}
              </button>
            </div>

            <div>
              <button
                className="btn bg-white px-5"
                style={{ width: "190px", border: "2px solid #000" }}
                onClick={modalClose}
              >
                Cancel
              </button>
            </div>
          </section>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default ModalPublishUnPublish;
